import React from "react";
import { Link } from "react-router-dom";

import cartEmptyImg from "../assets/img/empty-cart.png";

export default function CartEmpty() {
  return (
    <div className="cart cart--empty">
      <h2>
        The cart is empty <span>😕</span>
      </h2>
      <p>
        It seems like you don't choose any pizza.
        <br />
        To ordet some pizza go to the main page.
      </p>
      <img src={cartEmptyImg} alt="Empty cart" />
      <Link to="/" className="button button--black">
        <span>Go back</span>
      </Link>
    </div>
  );
}
